/* @ngInject */
export default function ($scope, AuthService, StaffReportsAdverseEventsService, DataTablesService, LayoutService, STATUSES, $timeout, toastr, ReportsService, $state) {
	LayoutService.setTitle('Adverse Events Report');

	const updateButton = LayoutService.getPageHeader()
	                                  .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

	const newButton = LayoutService.getPageHeader()
	                               .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-plus"></i> New</button>');

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       null,
			             displayName: 'Reports',
		             },
		             {
			             route:       'staff.reports.adverseEvents',
			             displayName: 'Adverse Events Report',
		             },
	             ]);

	$scope.loading = true;

	const financialYear = ReportsService.financialYear();

	$scope.cachedStart = $scope.start = financialYear.start;
	$scope.cachedEnd = $scope.end = financialYear.end;

	$scope.unloadReports = () => {
		$scope.reportLoaded = {
			summariesAdverseEvents:   false,
			individualsAdverseEvents: false,
		};
	};

	$scope.reportLoaded = {};

	$scope.activeTabs = {
		summaries:   0,
		individuals: 0,
	};

	$scope.$watch('activeTabs.summaries', () => {
		$timeout(() => {
			$scope.handleTabs();
		});
	});

	$scope.$watch('activeTabs.summaries', () => {
		$timeout(() => {
			$scope.handleTabs();
		});
	});

	$scope.handleTabs = () => {
		switch ($scope.activeTabs.summaries) {
			case 0: {
				$scope.reportLoaded.summariesAdverseEvents = true;

				break;
			}
		}

		switch ($scope.activeTabs.individuals) {
			case 0 : {
				$scope.reportLoaded.individualsAdverseEvents = true;

				break;
			}
		}
	};

	$scope.refresh = () => {
		$scope.cachedStart = $scope.start;
		$scope.cachedEnd   = $scope.end;

		$scope.dateRange = {
			start: $scope.cachedStart,
			end:   $scope.cachedEnd,
		};

		$scope.unloadReports();

		$timeout(() => {
			$scope.handleTabs();
		});
	};

	LayoutService.getPageHeader()
	             .onClicked(updateButton, $scope.refresh);

	LayoutService.getPageHeader()
	             .onClicked(newButton, () => {
		             $state.go('staff.reports.adverseEvents.new');
	             });


	$scope.refresh();
}


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/reports/adverseEvents/root/controller.js